import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';

Vue.use(VModal);
Vue.use(VueCookieBot, {
  cookieBotID: process.env.APP_COOKIEBOT_ID
});

// Register vue-awesome-swiper component
import(/* webpackChunkName: "components/vue-awesome-swiper" */ 'vue-awesome-swiper').then(
  ({ swiper, swiperSlide }) => {
    Vue.component('swiper', swiper);
    Vue.component('swiper-slide', swiperSlide);
  }
);

// Register Vue Slider Component
Vue.component('vue-slider', () =>
  import(/* webpackChunkName: "components/vendors/vue-slider" */ 'vue-slider-component')
);

// ---------------------------------------------------------------------------
// Register v-paginationcomponent
// ---------------------------------------------------------------------------
Vue.component('v-pagination', () =>
  import(/* webpackChunkName: "components/v-pagination" */ 'vue-plain-pagination')
);

// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
Vue.component('ald-badge', () =>
  import(/* webpackChunkName: "components/ald-badge" */ 'components/Badge')
);
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald-button" */ 'components/Button')
);
Vue.component('ald-input', () =>
  import(/* webpackChunkName: "components/ald-input" */ 'components/Input')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald-icon" */ 'components/Icon')
);
Vue.component('ald-card', () =>
  import(/* webpackChunkName: "components/ald-card" */ 'components/Card')
);
Vue.component('ald-advantages', () =>
  import(/* webpackChunkName: "components/ald-advantages" */ 'components/Advantages')
);
Vue.component('ald-collapse', () =>
  import(/* webpackChunkName: "components/ald-collapse" */ 'components/Collapse')
);
Vue.component('ald-button-group', () =>
  import(/* webpackChunkName: "components/ald-button-group" */ 'components/ButtonGroup')
);
Vue.component('ald-vehicles-filters', () =>
  import(/* webpackChunkName: "components/ald-vehicles-filters" */ 'components/VehiclesFilters')
);
Vue.component('ald-check-list', () =>
  import(/* webpackChunkName: "components/ald-check-list" */ 'components/CheckList')
);
// Vue.component('ald-pagination', () =>
//   import(/* webpackChunkName: "components/ald/ald-table-filters" */ 'components/Pagination')
// );
Vue.component('ald-pagination', () =>
  import(/* webpackChunkName: "components/ald/pagination" */ 'components/Pagination')
);
Vue.component('ald-select', () =>
  import(/* webpackChunkName: "components/ald/select" */ 'components/Select')
);
Vue.component('ald-showroom-filters', () =>
  import(/* webpackChunkName: "components/ald/ald-showroom-filters" */ 'components/ShowroomFilters')
);
Vue.component('ald-tab-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-tab-filter" */ 'components/TabFilter')
);
Vue.component('ald-tabs', () =>
  import(/* webpackChunkName: "components/ald/ald-tabs" */ 'components/Tabs')
);
Vue.component('ald-tab', () =>
  import(/* webpackChunkName: "components/ald/ald-tab" */ 'components/Tabs/Tab')
);
Vue.component('ald-input-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-input-filter" */ 'components/InputFilter')
);
Vue.component('ald-combo-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-combo-filter" */ 'components/ComboFilter')
);
Vue.component('ald-slide-filter', () =>
  import(/* webpackChunkName: "components/ald/ald-slide-filter" */ 'components/SlideFilter')
);
Vue.component('ald-custom-select', () =>
  import(/* webpackChunkName: "components/ald/ald-custom-select" */ 'components/CustomSelect')
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald/ald-transition" */ 'components/Transition')
);
Vue.component('ald-matrix', () =>
  import(/* webpackChunkName: "components/ald/matrix" */ 'components/Matrix')
);
Vue.component('ald-special-day-svg', () =>
  import(/* webpackChunkName: "components/ald/ald-special-day-svg" */ 'components/SpecialDaySvg')
);
